import "./styles.scss";

function Loader({ boxClassName, animate }) {
  return (
    <div className="boxContainer">
        <div className={`box ${animate ? "box1" : ""} ${boxClassName}`}></div>
        <div className={`box ${animate ? "box2" : ""} ${boxClassName}`}></div>
        <div className={`box ${animate ? "box3" : ""} ${boxClassName}`}></div>
        <div className={`box ${animate ? "box4" : ""} ${boxClassName}`}></div>
        <div className={`box ${animate ? "box5" : ""} ${boxClassName}`}></div>
    </div>
  );
}

export default Loader;
